import { render } from "./PageImages.vue?vue&type=template&id=5785272c&scoped=true"
import script from "./PageImages.vue?vue&type=script&lang=js"
export * from "./PageImages.vue?vue&type=script&lang=js"

import "./PageImages.vue?vue&type=style&index=0&id=5785272c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5785272c"]])

export default __exports__